import type { MutationHookOptions } from '@apollo/client'
import {
  BulkImportCertificatesDocument,
  BulkImportCertificatesMutation,
  BulkImportCertificatesMutationVariables,
  TrainingMembershipsDocument,
  TrainingMembershipsFileDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<
  BulkImportCertificatesMutation,
  BulkImportCertificatesMutationVariables
>

export const useBulkImportCertificates = (options?: Options) => {
  const [bulkImportMutation, { loading }] = useMutation(BulkImportCertificatesDocument, {
    ...options,
    extractorFn: (data) =>
      data.trainingsMutations.bulkImportCertificatesTrainingsTrainingMembershipFile,
  })

  return {
    loading,
    bulkImportCertificates(variables: BulkImportCertificatesMutationVariables) {
      return bulkImportMutation({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [TrainingMembershipsDocument, TrainingMembershipsFileDocument],
      })
    },
  }
}
